module.exports = __webpack_public_path__ + "img/partner-supyoga.b2dd7af4.jpg";